module.exports = __webpack_public_path__ + "img/SketchPngd21a84e6e41b0b46f963a7eac71a3e76ffba2e1c129d9490da483c60514a265b.f40d295a.png";